import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  menuHide: false,
  loading: false,
  error: false,
};

export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    hideStart: (state) => {
      state.loading = true;
    },
    hideSuccess: (state) => {
      state.menuHide = !state.menuHide;
      state.loading = false;
      state.error = false;
    },
    hideFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
  },
});

export const { hideStart, hideSuccess, hideFailure } = menuSlice.actions;
export default menuSlice.reducer;
